export const CANCEL_PERSON_ASSET_EDIT_STATE = "CANCEL_PERSON_ASSET_EDIT_STATE";
export const DELETE_PERSON_ASSET = "DELETE_PERSON_ASSET";
export const DELETE_PERSON_ASSET_BY_PERSON_ID = "DELETE_PERSON_ASSET_BY_PERSON_ID";
export const FETCH_PERSON_ASSET_LIST = "FETCH_PERSON_ASSET_LIST";
export const FETCH_PERSON_ASSET_LIST_BY_ID = "FETCH_PERSON_ASSET_LIST_BY_ID";
export const SAVE_EDITED_PERSON_ASSET = "SAVE_EDITED_PERSON_ASSET";
export const SAVE_NEW_PERSON_ASSET = "SAVE_NEW_PERSON_ASSET";
export const SAVE_NEW_PERSON_ASSET_BY_PERSON_ID = "SAVE_NEW_PERSON_ASSET_BY_PERSON_ID";
export const UPDATE_PERSON_ASSET = "UPDATE_PERSON_ASSET";
export const SAVE_EDITED_PERSON_ASSET_BY_PERSON_ID = "SAVE_EDITED_PERSON_ASSET_BY_PERSON_ID";


